module.exports = __webpack_public_path__ + "static/media/teltonika-fmu130-3.9c372ac5.png";